import { transformUtil } from 'js-utils/transformation';
import { Schema } from 'normalizr';

const INSTALLMENTS_RESPONSE_SCHEMA = new Schema('installments');

export const transformInstallmentsData = (data) => {
    const transformed = transformUtil({
        response: data,
        schema: INSTALLMENTS_RESPONSE_SCHEMA,
    });

    return Object.values(transformed.entities.installments)[0];
};
